import { asType } from '@sparky/framework'
import { CONNECTED_PLATFORMS, APP_ID_CASB_NGFW } from '../../common/constants/GlobalConstants'
import { ActivationManifest, PrimaryAppIds } from '../renderer'
import { CSP_LEARN_MORE_LINK } from '../constants'

export default asType<ActivationManifest>({
  activation_id: 'ng_casb',
  description: 'Next-Generation CASB for Prisma Access and NGFW',
  primary_app_id: PrimaryAppIds.NG_CASB,
  flags: {
    hash_required: true,
    cdl_required: false,
    amend_license: true,
    show_purchased_size_as_qty: true,
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.UDefaultActivationScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.UScreenHeader',
            props: {
              title: 'Activate Subscription',
              headerAppId: PrimaryAppIds.NG_CASB
            }
          },
          {
            key: 'activation-form',
            component: 'activation.UDefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'activation-section-csp',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Select Customer Support Account',
                    subtitle: 'This account is used for the registration and support of the products and add-ons that are bundled with this subscription.',
                    link: CSP_LEARN_MORE_LINK,
                    children: [
                      {
                        key: 'activation-accordion-csp',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Customer Support Account:',
                          children: [
                            {
                              key: 'default-dropdown-component-csp',
                              component: 'activation.UCSPComponent',
                              props: {
                              },
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-section-subscription',
                        component: 'activation.UActivationSection',
                        props: {
                          title: 'Allocate This Subscription',
                          subtitle: 'Allocate the available licenses and add-ons in this subscription to a recipient.',
                          children: [
                            {
                              key: 'activation-accordion-tsg',
                              component: 'activation.UAccordion',
                              props: {
                                title: 'Recipient:',
                                children: [
                                  {
                                    key: 'default-tsg-component',
                                    component: 'activation.UTSGComponent',
                                    props: {
                                    }
                                  },
                                ]
                              }
                            },
                            {
                              key: 'activation-accordion-region',
                              component: 'activation.UAccordion',
                              props: {
                                title: 'Region:',
                                children: [
                                  {
                                    key: 'default-region-component',
                                    component: 'activation.URegionComponent',
                                    props: {
                                    }
                                  },
                                ]
                              }
                            },
                            {
                              key: 'activation-accordion-platforms',
                              component: 'activation.UAccordion',
                              props: {
                                children: [
                                  {
                                    key: 'casbx-platforms',
                                    component: 'activation.UPlatformBanner',
                                    props: {
                                      title: 'Can be used on',
                                      connectedPlatforms: CONNECTED_PLATFORMS[PrimaryAppIds.NG_CASB],
                                      defaultPlatformId: APP_ID_CASB_NGFW,
                                      infoMessage: 'Thank you for activating NG CASB! If Firewalls need to be associated, please do so in the Device Association Tab.',
                                    }
                                  },
                                ]
                              }
                            },
                          ]
                        }
                      },
                    ]
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                }
              ],
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
